export default __webpack_public_path__ + "static/media/availability.467ad539.svg";